import { atom } from "recoil";
import { IModel } from "../types";

export const addStateModel = atom({
  key: "addStateModel",
  default: false,
});
export const editStateModel = atom({
  key: "editStateModel",
  default: false,
});
export const rowEditModel = atom<IModel | undefined>({
  key: "rowEditModel",
  default: undefined,
});

export const selectedRowsStateModel = atom<IModel[]>({
  key: "selectedRowsStateModel",
  default: [],
});

export const modelFilterText = atom({
  key: "modelFilterText",
  default: "",
});

export const savingModel = atom({
  key: "savingModel",
  default: false,
});
export const modelFetching = atom({
  key: "modelFetching",
  default: true,
});
